import { Box, Popover, styled } from '@mui/material';

export const SelectRoleContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['isOpened', 'isError', 'isHasValue', 'isTextVariantInput'].includes(prop),
})<{
  isOpened: boolean;
  isError?: boolean;
  isHasValue?: boolean;
  isTextVariantInput?: boolean;
}>(({ theme, isOpened, isError, isHasValue, isTextVariantInput }) => {
  let backgroundColor = theme.palette.case.neutral.n50;
  let borderColor = theme.palette.case.neutral.n200;
  const color = theme.palette.case.neutral.n700;
  if (isError) {
    borderColor = theme.palette.case.red.r300;
    backgroundColor = isOpened ? theme.palette.case.neutral.n0 : theme.palette.case.neutral.n50;
  } else if (isHasValue) {
    backgroundColor = theme.palette.case.neutral.n0;
  } else if (isOpened) {
    backgroundColor = theme.palette.case.neutral.n0;
    borderColor = theme.palette.case.aquamarine.a600;
  }
  return {
    width: '100%',
    height: '36px',
    border: isTextVariantInput ? 'none' : '1px solid',
    color: color,
    backgroundColor: isTextVariantInput ? 'none' : backgroundColor,
    borderColor: isTextVariantInput ? 'none' : borderColor,
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '6px',
    padding: isTextVariantInput ? '0px 8px 0px 6px' : '0 8px',
    position: 'relative',
    '&:hover': {
      backgroundColor: theme.palette.case.neutral.n0,
    },
  };
});

export const SelectRolePopoverContainer = styled(Popover)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiPaper-root': {
    padding: '10px',
    minWidth: '250px',
    boxSizing: 'border-box',
    boxShadow: theme.palette.case.shadow.big,
    display: 'flex',
    alignItems: 'center',
  },
}));

type SelectRolePopoverContentItemType = {
  isActive?: boolean;
};

export const SelectRolePopoverContentItem = styled(Box, {
  shouldForwardProp: (prop: string) => !['isActive'].includes(prop),
})<SelectRolePopoverContentItemType>(({ isActive, theme }) => ({
  borderRadius: '5px',
  minHeight: '29px',
  minWidth: '65px',
  marginBottom: '5px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  backgroundColor: isActive ? theme.palette.case.neutral.n100 : 'initial',
  '&:hover': {
    backgroundColor: theme.palette.case.neutral.n100,
  },
}));

export const SelectRolePopoverSkeletonContainer = styled(Box)(() => ({
  marginBottom: '5px',
  height: '29px',
  width: '100%',
  minWidth: '65px',
}));

export const SelectRolePopoverContentContainer = styled(Box)(() => ({
  display: 'flex',
  overflow: 'hidden',
}));

export const SelectRolePopoverLeftColumnContainer = styled(Box)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.case.neutral.n100}`,
  paddingRight: '10px',
}));

export const SelectRolePopoverRightColumnContainer = styled(Box)(() => ({
  height: '227px',
  overflow: 'auto',
  width: '100%',
  marginLeft: '10px',
}));
